export class Plan {
  monthlyId: number;
  yearlyId: number;
  title: string;
  monthlyPrice: number;
  yearlyPrice: number;
  hostedDomainsCount: number;
  ssdStorage: string;
  visitors: string;

  constructor(title: string, hostedDomainsCount: number, ssdStorage: string, visitors: string) {
    this.title = title;
    this.hostedDomainsCount = hostedDomainsCount;
    this.ssdStorage = ssdStorage;
    this.visitors = visitors;
  }

}
